"use strict";

module.exports = {
  isMobile: window.matchMedia("(max-width: 500px)"),
  /* common-shake removed: isDesktop: window.matchMedia("(min-width: 501px)") */
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJyZWFrcG9pbnRzLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJpc01vYmlsZSIsIndpbmRvdyIsIm1hdGNoTWVkaWEiLCJpc0Rlc2t0b3AiXSwibWFwcGluZ3MiOiI7O0FBQUFBLE1BQUFBLENBQU9DLE9BQVBELEdBQWlCO0VBQ2ZFLFFBQUFBLEVBQVVDLE1BQUFBLENBQU9DLFVBQVBELENBQWtCLG9CQUFsQkEsQ0FESztFQUVmRSw4RUFBV0Y7Q0FGYkgsQ0FBQUEiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==